export const QA_NAME_TASK_CREATION_MODAL = 'create_activity'
